// // import React, { useState, useEffect } from "react";
// // import { BsArrowRight } from "react-icons/bs";
// // import axios from "axios";
// // import { IoMdContacts } from "react-icons/io";
// // import { TiTick } from "react-icons/ti";
// // import "./pricing.css";
// // import { useNavigate } from "react-router-dom";
// // import { loadStripe } from "@stripe/stripe-js";
// // import singleUser from "../../Images/single-user.png";
// // import multiUser from "../../Images/group.png";
// // import leftArrow from "../../Images/arrow_cool_down.jpg";
// // import notificaton from "../../Images/notifications.jpg";
// // import docologo from "../../Images/doculogo.svg";
// // import cardCheck from "../../Images/card-check.jpg";
// // import { Header } from "../../components/Header/Header";
// // import Cookies from "js-cookie";
// // import api from "../chat/api";
// // const Pricing = () => {
// //   const [isMonthly, setIsMonthly] = useState(true);
// //   const [subscriptionId, setSubscriptionId] = useState(null);

// //   const navigate = useNavigate();
// //   const [selectedCard, setSelectedCard] = useState(null);
// //   const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY);
// //   const [isPopupOpen, setIsPopupOpen] = useState(false);
// //   const [isProcessingPayment, setIsProcessingPayment] = useState(false);
// //   const [isActivating, setIsActivating] = useState(false);
// //   const [showGetStarted, setShowGetStarted] = useState(false);

// //   const handleOpenPopup = (plan) => {
// //     if (plan.title === "Enterprise") {
// //       window.open("https://docusensa.com/contact-us", "_blank");
// //       return;
// //     }
// //     setSelectedPlan(plan);
// //     setIsProcessingPayment(false);
// //     const start = new Date();
// //     const end = new Date(start);

// //     if (plan.title === "Grow") {
// //       end.setFullYear(end.getFullYear() + 1);
// //     } else {
// //       end.setMonth(end.getMonth() + 1);
// //     }

// //     setUpgradeStartDate(start);
// //     setUpgradeEndDate(end);
// //     setIsPopupOpen(true); // Always show popup
// //     setSubscriptionId(null);
// //   };

// //   const [currencySymbol, setCurrencySymbol] = useState("$"); // Default USD
// //   const [countryCode, setCountryCode] = useState("");

// //   const [hasCancelledOnce, setHasCancelledOnce] = useState(false);

// //   const loadRazorpayScript = () => {
// //     return new Promise((resolve) => {
// //       const script = document.createElement("script");
// //       script.src = "https://checkout.razorpay.com/v1/checkout.js";
// //       script.async = true;
// //       script.onload = () => {
// //         resolve(true);
// //       };
// //       script.onerror = () => {
// //         resolve(false);
// //       };
// //       document.body.appendChild(script);
// //     });
// //   };

// //   const initializeRazorpay = async (subscriptionId) => {
// //     const isScriptLoaded = await loadRazorpayScript();
// //     if (!isScriptLoaded || !subscriptionId) return;

// //     const userName = localStorage.getItem("fullName") || "User";
// //     const userEmail = localStorage.getItem("email") || "user@example.com";
// //     const userContact = localStorage.getItem("user_contact") || "0000000000";

// //     const options = {
// //       key: "rzp_live_aCWZouiI1r4JJE",
// //       subscription_id: subscriptionId,
// //       name: "DocuSensa",
// //       description: `${selectedPlan?.title} Plan Subscription`,
// //       image: "/DocuSensaLogo.png",
// //       callback_url: window.location.origin + "/ai-Copilot",
// //       prefill: {
// //         name: userName,
// //         email: userEmail,
// //         contact: userContact,
// //       },
// //       theme: { color: "#C95EBE" },
// //       config: {
// //         display: {
// //           preferences: {
// //             show_default_blocks: false,
// //           },
// //         },
// //       },
// //       handler: async function (response) {
// //         const token = localStorage.getItem("token");
// //         const prevSubType = subscriptionStatus?.subscription_type;
// //         const prevPlanType = subscriptionStatus?.plan_type;
// //         let retryCount = 0;
// //         setIsActivating(true);
// //         const pollSubscription = async () => {
// //           try {
// //             const result = await api.get(
// //               `api/v1/accounts/get-subscription-status/`
// //             );

// //             const { subscription_type, plan_type, quota, message } =
// //               result.data;
// //             const isNowPaid = subscription_type === "paid_subs";
// //             const upgraded =
// //               (prevSubType === "trial" && plan_type === "yearly") ||
// //               (prevSubType === "trial" && plan_type === "monthly") ||
// //               (prevSubType === "paid_subs" &&
// //                 prevPlanType === "monthly" &&
// //                 plan_type === "yearly");

          

// //             const shouldNavigate =
// //               subscription_type === "trial" &&
// //               (quota === "monthly" || quota === "yearly") &&
// //               !plan_type.includes("paid_subs"); // Ensures it’s still a trial quota bump

// //             if (shouldNavigate || message) {
// //               setIsActivating(false);
// //               setShowGetStarted(true);
// //               return;
// //             }

// //             retryCount++;
// //             if (retryCount < 30) {
// //               setTimeout(pollSubscription, 4000); // 4 seconds
// //             } else {
// //               console.warn(
// //                 "⏱ Max retries reached. Manual refresh might be required."
// //               );
// //             }
// //           } catch (err) {
// //             console.error("❌ Polling error:", err);
// //             retryCount++;
// //             if (retryCount < 30) {
// //               setTimeout(pollSubscription, 4000);
// //             }
// //           }
// //         };

// //         setTimeout(() => {
// //           pollSubscription();
// //         }, 10000); // Give a buffer before polling starts
// //       },
// //       modal: {
// //         escape: false,
// //         ondismiss: function () {
// //         },
// //       },
// //     };

// //     const rzp = new window.Razorpay(options);
// //     rzp.open();
// //   };

// //   const token = localStorage.getItem("token");
// //   const [selectedPlan, setSelectedPlan] = useState(null);
// //   const handleClosePopup = () => {
// //     setIsPopupOpen(false);
// //     setSelectedPlan(null);
// //     setIsProcessingPayment(false);
// //   };

// //   const cardInfo = [
// //     {
// //       offer: "Limited Time Offer",
// //       ml: 50,
// //       title: "Start",
// //       planDes: "Monthly Plan - Flexible & Affordable",
// //       originalPrice: 60.99,
// //       discountedPrice: 39.0,
// //       button: {
// //         text: "Start Free Trial",
// //       },
// //       user: {
// //         logo: <img src={singleUser} alt="user" />,
// //         text: "1 user",
// //       },
// //       purchaseText: "Start Free Trial",
// //       points: [
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: (
// //             <>
// //               <span>Document Upload Limit:</span>
// //               <br />
// //               Upto 70 documents per month
// //             </>
// //           ),
// //         },
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "Daily Questions Limit: Unlimited",
// //         },
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "Maximum File Size: 25 MB",
// //         },
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "AI Co-Pilot with AI Search on Knowledgebase",
// //         },

// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: (
// //             <>
// //               <span>Multi-Document Chat:</span>
// //               <br />
// //               Chat with up to 5 documents simultaneously
// //             </>
// //           ),
// //         },
// //         {
// //           icon: "/cross-pricisng-visible.svg",
// //           text: (
// //             <>
// //               <span>Advanced OCR ID Data Extraction.</span>
// //             </>
// //           ),
// //         },

// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "Advanced Contracts & Invoice Data Extraction ",
// //         },

// //         {
// //           icon: "/cross-pricisng-visible.svg",
// //           text: (
// //             <>
// //               <span>AI RFP Response Writer</span>
// //             </>
// //           ),
// //         },
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "Support Level: Standard support included",
// //         },

// //         {
// //           icon: "/features-icon-seven-pay.svg",
// //           text: (
// //             <>
// //               <span className="coming-soon-text">Coming Soon:</span>
// //               Custom Fields Extraction
// //             </>
// //           ),
// //         },

// //         {
// //           icon: "/features-icon-seven-pay.svg",
// //           text: (
// //             <>
// //               <span className="coming-soon-text">Coming Soon:</span>
// //               Includes Google Drive and OneDrive integrations
// //             </>
// //           ),
// //         },
// //       ],
// //     },
// //     {
// //       offer: "Recommended",
// //       ml: 70,
// //       title: "Grow",
// //       planDes: "Yearly Plan - Saves more",
// //       originalPrice: 299.99,
// //       discountedPrice: 199.0,
// //       button: {
// //         text: "Start Free Trial",
// //       },
// //       user: {
// //         logo: <img src={multiUser} alt="multi-user" />,
// //         text: "Multiple Users",
// //       },
// //       purchaseText: "Purchase Pro",
// //       points: [
// //         {
// //           icon: "/features-icon-two-icon.svg",
// //           text: (
// //             <>
// //               <span>Document Upload Limit:</span>
// //               Unlimited
// //             </>
// //           ),
// //         },
// //         {
// //           icon: "/features-icon-two-icon.svg",
// //           text: "Daily Questions Limit: Unlimited",
// //         },
// //         {
// //           icon: "/features-icon-two-icon.svg",
// //           text: "Maximum File Size: 50 MB",
// //         },
// //         {
// //           icon: "/features-icon-two-icon.svg",
// //           text: "AI Co-Pilot with AI Search on Knowledgebase",
// //         },

// //         {
// //           icon: "/features-icon-two-icon.svg",
// //           text: (
// //             <>
// //               <span>Multi-Document Chat:</span>
// //               <br />
// //               Chat with up to 10 documents simultaneously
// //             </>
// //           ),
// //         },

// //         {
// //           icon: "/features-icon-two-icon.svg",
// //           text: "Advanced Contracts & Invoice Data Extraction ",
// //         },

// //         {
// //           icon: "/features-icon-two-icon.svg",
// //           text: "Support Level: Standard support included",
// //         },
// //         {
// //           icon: "/cross-pricisng-visible-black.svg",
// //           text: (
// //             <>
// //               <span className="coming-soon-text-recom">Coming Soon:</span>
// //               Includes Google Drive and OneDrive integrations
// //             </>
// //           ),
// //         },

// //         {
// //           icon: "/cross-pricisng-visible-black.svg",
// //           text: (
// //             <>
// //               <span className="coming-soon-text-recom">Coming Soon:</span>
// //               Custom Field Extraction
// //             </>
// //           ),
// //         },
// //       ],
// //     },

// //     {
// //       offer: "Coming Soon",
// //       ml: 80,
// //       title: "Enterprise",
// //       planDes: "Ideal for Organisations",
// //       originalPrice: null,
// //       discountedPrice: "",
// //       button: {
// //         text: "Contact Sales",
// //       },
// //       user: {
// //         logo: <img src={multiUser} alt="multi-user" />,
// //         text: "Multiple Users",
// //       },
// //       purchaseText: "Contact Sales",
// //       points: [
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: (
// //             <>
// //               <span>Document Upload Limit:Everything on Grow</span>
// //             </>
// //           ),
// //         },
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "Advanced OCR ID Data Extraction:",
// //         },
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "AI RFP Response Writer",
// //         },
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "Google Drive Integration",
// //         },

// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "One Drive Integration",
// //         },

// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "Custom field Extraction",
// //         },

// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "SSO and SAML",
// //         },
// //         {
// //           icon: "/features-icon-one-icon.svg",
// //           text: "Dedicated Customer Success Manager",
// //         },
// //       ],
// //     },
// //   ];

// //   const handlePaymentFrequencyChange = (frequency) => {
// //     setIsMonthly(frequency);
// //   };
// //   // const handlePaymentFrequencyChange = (isMonthly) => {
// //   //   setIsMonthly(isMonthly);
// //   // };
// //   const handleCardClick = (index) => {
// //     setSelectedCard(index); // Set the clicked card as the selected one
// //   };

// //   const getBackgroundColor = (title) => {
// //     switch (title) {
// //       case "Start":
// //         return "#ECE0FD"; // Background for Starter plan
// //       case "Grow":
// //         return "rgba(201, 94, 190, 0.20)"; // Background for Pro plan
// //       case "Enterprise":
// //         return "#ECE0FD"; // Background for Pro+ plan
// //       default:
// //         return "white"; // Default background
// //     }
// //   };
// //   const getTextColor = (title) => {
// //     switch (title) {
// //       case "Start":
// //         return "#8B55DD";
// //       case "Grow":
// //         return "#C95EBE";
// //       case "Enterprise":
// //         return "linear-gradient(90deg, #8B55DD 0%, #8B55DD 100%)"; // Background for Pro+ plan
// //       default:
// //         return "white";
// //     }
// //   };

// //   const getButtonColor = (title) => {
// //     switch (title) {
// //       case "Start":
// //         return "#8B55DD";
// //       case "Grow":
// //         return "#8B55DD";
// //       case "Enterprise":
// //         return "#C95EBE";
// //       default:
// //         return "black";
// //     }
// //   };

// //   const getButtonBorderColor = (title) => {
// //     switch (title) {
// //       case "Start":
// //         return "#8B55DD";
// //       case "Grow":
// //         return "#8B55DD";
// //       case "Enterprise":
// //         return "#C95EBE";
// //       default:
// //         return "black";
// //     }
// //   };
// //   // const handleNavigation = () => {
// //   //   if (cardInfo.title === "Starter") {
// //   //     navigate("/uploadFile");
// //   //   }
// //   // };
// //   const handleNavigation = () => {
// //     navigate("/ai-Copilot");
// //   };

// //   const getLink = () => {
// //     return isMonthly
// //       ? "https://rzp.io/rzp/docusensa-testing" // Monthly Razorpay link
// //       : "https://pages.razorpay.com/pl_PBk8xMY3wOv18X/view"; // Yearly Razorpay link
// //   };

// //   const [plans, setPlans] = useState([]);
// //   const [userIP, setUserIP] = useState("103.108.4.82");
// //   const fetchPlans = async () => {
// //     try {
// //       const response = await api.get(`api/v1/accounts/get-plans/`);

// //       if (response.status === 200) {
// //         const { ip_address, currency, country_code } = response.data;
// //         setUserIP(ip_address);
// //         setCountryCode(country_code);

// //         if (currency === "INR") {
// //           setCurrencySymbol("₹");
// //         } else {
// //           setCurrencySymbol("$");
// //         }
// //       }
// //     } catch (error) {
// //       console.error("Error fetching plans:", error);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchPlans();
// //   }, []);

// //   const [upgradeStartDate, setUpgradeStartDate] = useState(null);
// //   const [upgradeEndDate, setUpgradeEndDate] = useState(null);

// //   const formatPopupDate = (dateObj) => {
// //     if (!dateObj) return "";
// //     const day = String(dateObj.getDate()).padStart(2, "0");
// //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
// //     const year = dateObj.getFullYear();
// //     return `${day}-${month}-${year}`;
// //   };

// //   const [subscriptionStatus, setSubscriptionStatus] = useState(null);

// //   const fetchSubscriptionStatus = async () => {
// //     try {
// //       const response = await api.get(
// //         "api/v1/accounts/get-subscription-status/"
// //       );

// //       if (response.status === 200) {
// //         const data = response.data;
// //         setSubscriptionStatus(response.data);
// //         if (
// //           data?.subscription_type === "paid_subs" &&
// //           (data?.plan_type === "yearly" || data?.plan_type === "monthly")
// //         ) {
// //           navigate("/ai-Copilot");
// //           return;
// //         }
// //         if (
// //           data?.subscription_type === "trial_expired" ||
// //           response.data?.expired_or_cancelled_subscription?.subscription_type === "subscription_expired"
// //         ) {
// //           setHasCancelledOnce(true);
// //         }
// //         const { quota, plan_type } = data;
// //         if (quota === "monthly" && plan_type === "trial") {
// //           navigate("/ai-Copilot");
// //           return;
// //         }

// //         // Optional: log entire response
// //       }
// //     } catch (error) {
// //       if (error.response && error.response.data) {
// //         const data = error.response.data;
// //         if (data?.subscription_type === "trial_expired") {
// //           setHasCancelledOnce(true);
// //         }
// //       }
// //       console.error("Error fetching subscription status:", error);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchSubscriptionStatus(); // Fetch subscription status on load
// //   }, []);

// //   const formatPrice = (usd, inr) => {
// //     return currencySymbol === "₹" ? `₹${inr}` : `$${usd}`;
// //   };

// //   const handleSubscribe = async () => {
// //     if (!selectedPlan) {
// //       console.error("🚨 No plan selected");
// //       return;
// //     }

// //     const planType = selectedPlan.title === "Grow" ? "yearly" : "monthly";
// //     const headers = {};

// //     if (
// //       hasCancelledOnce &&
// //       (selectedPlan.title === "Start" || selectedPlan.title === "Grow")
// //     ) {
// //       headers["X-Forwarded-For"] = userIP;
// //       setIsProcessingPayment(true);

// //       let attempts = 0;
// //       const maxAttempts = 30;
// //       const delay = 3000; // 3 seconds

// //       const pollForCheckoutUrl = async () => {
// //         try {
// //           const response = await api.post(
// //             "api/v1/accounts/create-subscription/",
// //             {
// //               plan_type: planType,
// //               currency: currencySymbol === "₹" ? "INR" : "USD",
// //             },
// //             { headers }
// //           );

// //           const { checkout_url } = response.data;

// //           if (checkout_url) {
// //             window.location.href = checkout_url;
// //             return;
// //           } else {
// //             attempts++;
// //             if (attempts < maxAttempts) {
// //               setTimeout(pollForCheckoutUrl, delay);
// //             } else {
// //               throw new Error(
// //                 "Checkout URL not available after multiple attempts."
// //               );
// //             }
// //           }
// //         } catch (error) {
// //           console.error(`❌ Attempt ${attempts + 1} failed:`, error);
// //           attempts++;
// //           if (attempts < maxAttempts) {
// //             setTimeout(pollForCheckoutUrl, delay);
// //           } else {
// //             alert(
// //               error?.response?.data?.message ||
// //                 error.message ||
// //                 "Failed to create subscription after multiple attempts."
// //             );
// //             setIsProcessingPayment(false);
// //           }
// //         }
// //       };

// //       pollForCheckoutUrl();
// //       return; // Skip trial logic if doing direct subscription
// //     }

// //     try {
// //       setIsProcessingPayment(true);

// //       const response = await api.post(
// //         "api/v1/accounts/start-trial/",
// //         { plan_type: planType },
// //         { headers }
// //       );

// //       const data = response.data;

// //       if (
// //         data.message === "Trial started successfully" ||
// //         data.message === "Trial already exists."
// //       ) {
// //         setIsPopupOpen(false);
// //         setShowGetStarted(true);
// //       } else {
// //         throw new Error(data.message || "Unexpected response");
// //       }
// //     } catch (error) {
// //       console.error("❌ Error starting trial:", error);
// //       const errMessage =
// //         error?.response?.data?.message ||
// //         error.message ||
// //         "Failed to start trial";
// //       alert(errMessage);
// //       setIsProcessingPayment(false);
// //     }
// //   };

// //   return (
// //     <div className="plan-page">
// //           {/* Fixed Header Wrapper */}
// //           <div className="w-full relative sticky top-0 z-[100] bg-white">
// //         <Header 
// //           image={docologo} 
// //           name="" 
// //         />
        
// //         {/* Perfectly centered title overlay */}
// //         <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
// //           <span className="whitespace-nowrap text-lg font-semibold text-black md:text-xl">
// //             Choose the best Plan for You
// //           </span>
// //         </div>
// //       </div>

// //       <div className="mid-section w-full h-full mt-2">
        
// //         <div className="price-card-container w-full h-full flex md:flex-row  items-center justify-center gap-6  relative">
// //           {cardInfo.map((card, index) => (
// //             <div
// //               key={index}
// //               onClick={() => handleCardClick(index)}
// //               className={`card flex flex-col  p-6 transition-all duration-300`}
// //               style={{
// //                 width: "21.56rem",
// //                 minHeight: index === 1 ? "36.5rem" : "33.44rem",
// //                 borderRadius: "1rem",
// //                 border: "1px solid rgba(0, 0, 0, 0.10)",
// //                 marginTop: index === 1 ? "3rem" : "",
// //                 display: "flex",
// //                 flexDirection: "column",
// //                 justifyContent: "space-between",
// //                 position: "relative",
// //                 backgroundColor: index === 1 ? "#8B55DD" : "white",
// //               }}
// //             >
// //               {index !== 0 && (
// //                 <div
// //                   className="offers-pay-terms"
// //                   style={
// //                     index === 2
// //                       ? {
// //                           width: "123px",
// //                           height: "28px",
// //                           flexShrink: 0,
// //                           borderRadius: "4px",
// //                           background:
// //                             "linear-gradient(91deg, rgba(201, 94, 190, 0.40) 16.63%, rgba(139, 85, 221, 0.40) 83.27%)",
// //                           color: "#8B55DD",
// //                           fontFamily: "Outfit",
// //                           fontSize: "14px",
// //                           fontStyle: "normal",
// //                           fontWeight: 500,
// //                           lineHeight: "normal",
// //                           display: "flex",
// //                           alignItems: "center",
// //                           justifyContent: "center",
// //                           marginLeft: "1px",
// //                         }
// //                       : index === 1
// //                       ? {
// //                           background: "#FFFFFF",
// //                         }
// //                       : {}
// //                   }
// //                 >
// //                   <span className="offers-text-pay">{card.offer}</span>
// //                 </div>
// //               )}

// //               <div
// //                 className={`flex flex-col items-center justify-center text-center ${
// //                   index === 0 ? "mt-7" : ""
// //                 }`}
// //                 style={{ marginLeft: `${card.ml}px` }}
// //               >
// //                 <h3
// //                   className="text-lg font-bold text-[#18101C]"
// //                   style={{
// //                     color: index === 1 ? "#FFF" : "",
// //                   }}
// //                 >
// //                   {card.title}
// //                 </h3>
// //                 <p
// //                   className="plan-des"
// //                   style={{
// //                     color: index === 1 ? "#FFF" : "",
// //                   }}
// //                 >
// //                   {card.planDes}
// //                 </p>
// //               </div>

// //               {/* Price */}
// //               {/* Pricing Section */}
// //               <div
// //                 className="card-price text-center font-semibold text-[#18101C] text-2xl flex items-center justify-center gap-2 ml-12"
// //                 style={{
// //                   marginLeft: index === 2 ? "6.5rem" : "2.95rem",
// //                   justifyContent: "flex-start",
// //                 }}
// //               >
// //                 {card.originalPrice !== null ? (
// //                   <>
// //                     {/* Strikethrough Original Price */}
// //                     <span
// //                       className="text-[#C95EBE] text-lg line-through pay-original-price"
// //                       style={{
// //                         color: index === 1 ? "#FFF" : "",
// //                       }}
// //                     >
// //                       {formatPrice(
// //                         card.originalPrice,
// //                         card.title === "Grow" ? "25,675.30" : "5,219.96"
// //                       )}
// //                     </span>

// //                     <span
// //                       className="text-black pay-discount-price"
// //                       style={{
// //                         color: index === 1 ? "#FFF" : "",
// //                       }}
// //                     >
// //                       {formatPrice(
// //                         card.discountedPrice,
// //                         card.title === "Grow" ? "17,032.00" : "3,338.00"
// //                       )}
// //                     </span>
// //                     <sub
// //                       className="pay-discount-price-des"
// //                       style={{
// //                         color: index === 1 ? "#FFF" : "",
// //                       }}
// //                     >
// //                       {card.title === "Grow" ? "/year" : "/month"}
// //                     </sub>
// //                   </>
// //                 ) : (
// //                   <span className="comming-sson-pay">/Coming Soon</span>
// //                 )}
// //               </div>

// //               <div
// //                 style={{
// //                   width: "299px",
// //                   height: "1px",
// //                   // margin: "16px auto",
// //                   marginLeft: "15px",

// //                   background:
// //                     index === 1
// //                       ? "linear-gradient(111deg, #F5EEFF 14.52%, #FDFDFD 99.31%)"
// //                       : "linear-gradient(180deg, #C95EBE 0%, #8B55DD 100%)",
// //                 }}
// //               ></div>

// //               <div className="flex flex-col gap-2 ml-4">
// //                 {/* Heading with Icon */}
// //                 <div
// //                   className=""
// //                   style={{
// //                     display: "inline-flex",
// //                     padding: "6px 16px",
// //                     // justifyContent: "center",
// //                     // alignItems: "center",
// //                     width: "154px",
// //                     gap: "6px",
// //                     borderRadius: "24px",
// //                     background:
// //                       index === 1
// //                         ? "linear-gradient(111deg, #F5EEFF 14.52%, #FDFDFD 99.31%)"
// //                         : "rgba(187, 66, 174, 0.24)",
// //                   }}
// //                 >
// //                   {index === 0 || index === 2 ? (
// //                     <img
// //                       src="/stars-pay.svg"
// //                       alt="star icon"
// //                       className="w-5 h-5"
// //                     />
// //                   ) : index === 1 ? (
// //                     <img
// //                       src="/black-star-pricisng.svg"
// //                       alt="star icon"
// //                       className="w-5 h-5"
// //                     />
// //                   ) : null}

// //                   <h4
// //                     style={{
// //                       color: index === 1 ? "#171717" : "#BB42AE",
// //                       fontFamily: "Outfit",
// //                       fontSize: "14px",
// //                       fontStyle: "normal",
// //                       fontWeight: 500,
// //                       lineHeight: "normal",
// //                       letterSpacing: "-0.28px",
// //                       margin: 0,
// //                     }}
// //                   >
// //                     What's Included
// //                   </h4>
// //                 </div>

// //                 <div
// //                   className="points-container mt-0"
// //                   style={{
// //                     maxHeight: card.title === "Enterprise" ? "227px" : "250px",
// //                     maxHeight: card.title === "Grow" ? "302px" : "",
// //                     overflowY: "auto",
// //                   }}
// //                 >
// //                   {card.points.map((point, pointIndex) => (
// //                     <div
// //                       key={index}
// //                       className="flex items-start text-gray-800 text-sm"
// //                     >
// //                       <img
// //                         src={point.icon}
// //                         alt="feature icon"
// //                         className="w-5 h-5 mr-3 mt-0"
// //                       />
// //                       <div
// //                         className="des-features-pay"
// //                         style={{
// //                           color: index === 1 ? "#FFF" : "",
// //                         }}
// //                       >
// //                         {point.text}
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>

// //               <div
// //                 style={{
// //                   marginBottom: "-10px",
// //                   ...(hasCancelledOnce &&
// //                   (card.title === "Start" || card.title === "Grow")
// //                     ? { marginLeft: "25px" }
// //                     : {}), // Apply only for Proceed
// //                 }}
// //               >
// //                 <button
// //                   className="card-btn w-full py-3 rounded-lg font-semibold text-lg transition duration-300 flex items-center justify-center gap-2"
// //                   onClick={() => handleOpenPopup(card)}
// //                   style={{
// //                     color: getButtonColor(card.title),
// //                     border:
// //                       index === 1
// //                         ? "2px solid #FFF"
// //                         : `2px solid ${getButtonBorderColor(card.title)}`,
// //                   }}
// //                 >
// //                   <span
// //                     className="flex items-center"
// //                     style={{
// //                       color: index === 1 ? "#FFF" : "",
// //                     }}
// //                   >
// //                     {hasCancelledOnce &&
// //                     (card.title === "Start" || card.title === "Grow")
// //                       ? "Proceed"
// //                       : card.button.text}

// //                     <img
// //                       src={
// //                         index === 2
// //                           ? "/call-new-icon.svg"
// //                           : index === 1
// //                           ? "/pay-icon-trail-whites.svg" // replace with your icon for index 2
// //                           : "/pay-icon-trail.svg"
// //                       }
// //                       alt="icon"
// //                       className={`w-5 h-5 ${
// //                         index === 2 ? "ml-2 mt-1" : "ml-[3px]"
// //                       }`}
// //                     />
// //                   </span>
// //                 </button>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //       {isPopupOpen && (
// //         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //           <div className="popup-content">
// //             <span className="close-btn" onClick={handleClosePopup}>
// //               &times;
// //             </span>

// //             <h2 className="custom-popup-title-pricisng">
// //               {selectedPlan === "Start"
// //                 ? "Start Your 14-Day Free Trial Today!"
// //                 : selectedPlan === "Grow"
// //                 ? "Confirm Your Plan Upgrade"
// //                 : "Get Started with Your Plan"}
// //             </h2>

// //             <p className="custom-popup-subtext">
// //               {selectedPlan === "Grow"
// //                 ? "You're upgrading to the full version of your plan. Enjoy all premium features!"
// //                 : "Review your selection and start enjoying premium features right away"}
// //             </p>

// //             {/* Plan Details */}
// //             <div className="popup-plan-details-pricisng">
// //               <div className="popup-plan-header">
// //                 <span className="popup-free">Free for 14-days</span>
// //                 <span className="popup-free-monthly">Billed monthly</span>
// //               </div>
// //               <div>
// //                 <div className="popup-plan-info">
// //                   <div className="popup-plan-column ml-4">
// //                     <p className="popup-title">Plan</p>
// //                     <p className="popup-value">{selectedPlan?.title} Plan</p>
// //                   </div>
// //                   <div
// //                     className="popup-plan-column"
// //                     style={{ marginLeft: "104px" }}
// //                   >
// //                     <p className="popup-title">Price</p>
// //                     <p className="popup-value">
// //                       {selectedPlan?.title === "Grow"
// //                         ? `${currencySymbol}${
// //                             currencySymbol === "₹" ? "17,032.00" : "299.00"
// //                           }`
// //                         : `${currencySymbol}${
// //                             currencySymbol === "₹" ? "3,338.00" : "39.00"
// //                           }`}
// //                       <sub>/month</sub>
// //                     </p>
// //                   </div>
// //                   <div className="popup-plan-column ml-4">
// //                     <p className="popup-title">Start Date</p>
// //                     <p className="popup-value">
// //                       {formatPopupDate(upgradeStartDate)}
// //                     </p>
// //                   </div>
// //                   <div
// //                     className="popup-plan-column"
// //                     style={{ marginLeft: "104px" }}
// //                   >
// //                     <p className="popup-title">End Date</p>
// //                     <p className="popup-value">
// //                       {formatPopupDate(upgradeEndDate)}
// //                     </p>
// //                   </div>
// //                 </div>
// //                 <p className="popup-extra-text">
// //                   {hasCancelledOnce
// //                     ? "You're just a step away from reactivating your premium features. No trial — direct activation on secure payment."
// //                     : `No payment or card required to start the trial. Just click below and begin exploring DocuSensa’s premium features!`}
// //                 </p>
// //               </div>
// //             </div>

// //             {/* Terms and Proceed Button */}
// //             <p className="popup-terms">
// //               By clicking below, you agree to our{" "}
// //               <strong>Terms of Service</strong> and{" "}
// //               <strong>Privacy Policy</strong>.
// //             </p>
// //             <div
// //               className={`popup-button ${
// //                 isProcessingPayment ? "disabled-popup-button" : ""
// //               }`}
// //               onClick={!isProcessingPayment ? handleSubscribe : undefined}
// //             >
// //               <p className="popup-button-payment">
// //                 {isProcessingPayment
// //                   ? hasCancelledOnce
// //                     ? "Please wait ⏳ Redirecting to Stripe..."
// //                     : "Please wait ⏳ Redirecting to Docusensa..."
// //                   : hasCancelledOnce
// //                   ? "Proceed to Secure Payment"
// //                   : "Start Free Trial Now"}
// //               </p>

// //               <p>
// //                 {hasCancelledOnce
// //                   ? "Your card will be charged immediately to activate your subscription."
// //                   : "You’ll be redirected to Docusensa to start your 14 days trial."}
// //               </p>
// //             </div>
// //             {/* <div className="flex gap-2">
// //               <img
// //                 src="/pricising-secure.svg"
// //                 alt="celebration left"
// //                 className="mt-1"
// //               ></img>

// //               <p className="popup-payment-note">
// //                 You’ll be securely redirected to Razorpay to complete your card
// //                 setup.
// //               </p>
// //             </div> */}
// //           </div>
// //         </div>
// //       )}

// //       {/* ACTIVATION IN PROGRESS POPUP */}
// //       {isActivating && (
// //         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //           <img
// //             src="/leftside-celebration.svg"
// //             alt="celebration left"
// //             style={{
// //               position: "absolute",
// //               top: "50%",
// //               left: "32rem",
// //               transform: "translateY(-50%)",

// //               zIndex: 1,
// //             }}
// //           />

// //           {/* Right side image */}
// //           <img
// //             src="/right-side-celebration.svg"
// //             alt="celebration right"
// //             style={{
// //               position: "absolute",
// //               top: "50%",
// //               left: "49rem",
// //               transform: "translateY(-50%)",

// //               zIndex: 1,
// //             }}
// //           />
// //           <div className="activation-popup">
// //             <img
// //               src="/celebrate-icon.svg"
// //               alt="confetti"
// //               className="confetti-icon"
// //             />

// //             <h2>Welcome on board!</h2>
// //             <p>
// //               ✨ We’re setting up your premium features...
// //               <br />
// //               Hang tight, this will take just a moment!
// //             </p>
// //             <button disabled className="activating-btn">
// //               <span className="typing-animation">Activating your account</span>
// //             </button>
// //           </div>
// //         </div>
// //       )}

// //       {/* ACTIVATION COMPLETE POPUP showGetStarted && */}
// //     {showGetStarted && (
// //   (() => {
// //     setTimeout(() => {
// //       setShowGetStarted(false);
// //       navigate("/ai-Copilot"); // Use navigate instead of window.location.href
// //     }, 3000); // 2-second delay

// //     return (
// //         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
// //           <img
// //             src="/leftside-celebration.svg"
// //             alt="celebration left"
// //             style={{
// //               position: "absolute",
// //               top: "50%",
// //               left: "32rem",
// //               transform: "translateY(-50%)",

// //               zIndex: 1,
// //             }}
// //           />

// //           {/* Right side image */}
// //           <img
// //             src="/right-side-celebration.svg"
// //             alt="celebration right"
// //             style={{
// //               position: "absolute",
// //               top: "50%",
// //               left: "49rem",
// //               transform: "translateY(-50%)",

// //               zIndex: 1,
// //             }}
// //           />
// //           <div className="activation-popup">
// //             <img
// //               src="/celebrate-icon.svg"
// //               alt="confetti"
// //               className="confetti-icon"
// //             />
// //             <h2>You're all set!</h2>
// //             <p>
// //               Ready to unlock the full potential of your documents?
// //               <br />
// //               Your 14-day free trial starts now!
// //             </p>
// //             <button
// //               className="activating-btn"
// //               onClick={() => {
// //                 setShowGetStarted(false);
// //                 window.location.href = "/ai-Copilot";
// //               }}
// //             >
// //               Get Started Now
// //             </button>
// //           </div>
// //         </div>
// //            );
// //         })()
// // )}
// //     </div>
// //   );
// // };

// // export default Pricing;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { loadStripe } from "@stripe/stripe-js";
// import singleUser from "../../Images/single-user.png";
// import multiUser from "../../Images/group.png";
// import docologo from "../../Images/doculogo.svg";
// import { Header } from "../../components/Header/Header";
// import api from "../chat/api";

// const Pricing = () => {
//   const [isMonthly, setIsMonthly] = useState(true);
//   const [subscriptionId, setSubscriptionId] = useState(null);

//   const navigate = useNavigate();
//   const [selectedCard, setSelectedCard] = useState(null);
//   const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY);
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [isProcessingPayment, setIsProcessingPayment] = useState(false);
//   const [isActivating, setIsActivating] = useState(false);
//   const [showGetStarted, setShowGetStarted] = useState(false);
//   const [currencySymbol, setCurrencySymbol] = useState("$");
//   const [countryCode, setCountryCode] = useState("");
//   const [hasCancelledOnce, setHasCancelledOnce] = useState(false);
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [upgradeStartDate, setUpgradeStartDate] = useState(null);
//   const [upgradeEndDate, setUpgradeEndDate] = useState(null);
//   const [subscriptionStatus, setSubscriptionStatus] = useState(null);
//   const [plans, setPlans] = useState([]);
//   const [userIP, setUserIP] = useState("103.108.4.82");

//   const handleOpenPopup = (plan) => {
//     if (plan.title === "Enterprise") {
//       window.open("https://docusensa.com/contact-us", "_blank");
//       return;
//     }
//     setSelectedPlan(plan);
//     setIsProcessingPayment(false);
//     const start = new Date();
//     const end = new Date(start);

//     if (plan.title === "Grow") {
//       end.setFullYear(end.getFullYear() + 1);
//     } else {
//       end.setMonth(end.getMonth() + 1);
//     }

//     setUpgradeStartDate(start);
//     setUpgradeEndDate(end);
//     setIsPopupOpen(true);
//     setSubscriptionId(null);
//   };

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.async = true;
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const initializeRazorpay = async (subscriptionId) => {
//     const isScriptLoaded = await loadRazorpayScript();
//     if (!isScriptLoaded || !subscriptionId) return;

//     const userName = localStorage.getItem("fullName") || "User";
//     const userEmail = localStorage.getItem("email") || "user@example.com";
//     const userContact = localStorage.getItem("user_contact") || "0000000000";

//     const options = {
//       key: "rzp_live_aCWZouiI1r4JJE",
//       subscription_id: subscriptionId,
//       name: "DocuSensa",
//       description: `${selectedPlan?.title} Plan Subscription`,
//       image: "/DocuSensaLogo.png",
//       callback_url: window.location.origin + "/ai-Copilot",
//       prefill: { name: userName, email: userEmail, contact: userContact },
//       theme: { color: "#C95EBE" },
//       config: { display: { preferences: { show_default_blocks: false } } },
//       handler: async function (response) {
//         const prevSubType = subscriptionStatus?.subscription_type;
//         const prevPlanType = subscriptionStatus?.plan_type;
//         let retryCount = 0;
//         setIsActivating(true);
//         const pollSubscription = async () => {
//           try {
//             const result = await api.get(`api/v1/accounts/get-subscription-status/`);
//             const { subscription_type, plan_type, quota, message } = result.data;

//             const shouldNavigate =
//               subscription_type === "trial" &&
//               (quota === "monthly" || quota === "yearly") &&
//               !plan_type.includes("paid_subs");

//             if (shouldNavigate || message) {
//               setIsActivating(false);
//               setShowGetStarted(true);
//               return;
//             }

//             retryCount++;
//             if (retryCount < 30) {
//               setTimeout(pollSubscription, 4000);
//             } else {
//               console.warn("⏱ Max retries reached. Manual refresh might be required.");
//             }
//           } catch (err) {
//             console.error("❌ Polling error:", err);
//             retryCount++;
//             if (retryCount < 30) setTimeout(pollSubscription, 4000);
//           }
//         };

//         setTimeout(() => pollSubscription(), 10000);
//       },
//       modal: { escape: false, ondismiss: function () {} },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };

//   const handleClosePopup = () => {
//     setIsPopupOpen(false);
//     setSelectedPlan(null);
//     setIsProcessingPayment(false);
//   };

//   const cardInfo = [
//     {
//       offer: "Limited Time Offer",
//       title: "Start",
//       planDes: "Monthly Plan - Flexible & Affordable",
//       originalPrice: 60.99,
//       discountedPrice: 39.0,
//       priceUnit: "/month",
//       button: { text: "Start Free Trial" },
//       user: { logo: <img src={singleUser} alt="user" />, text: "1 user" },
//       points: [
//         {
//           icon: "/features-icon-one-icon.svg",
//           text: (
//             <>
//               <span>Document Upload Limit:</span>
//               <br />
//               Upto 70 documents per month
//             </>
//           ),
//         },
//         { icon: "/features-icon-one-icon.svg", text: "Daily Questions Limit: Unlimited" },
//         { icon: "/features-icon-one-icon.svg", text: "Maximum File Size: 25 MB" },
//         { icon: "/features-icon-one-icon.svg", text: "AI Co-Pilot with AI Search on Knowledgebase" },
//         {
//           icon: "/features-icon-one-icon.svg",
//           text: (
//             <>
//               <span>Multi-Document Chat:</span>
//               <br />
//               Chat with up to 5 documents simultaneously
//             </>
//           ),
//         },
//         { icon: "/cross-pricisng-visible.svg", text: "Advanced OCR ID Data Extraction." },
//         { icon: "/features-icon-one-icon.svg", text: "Advanced Contracts & Invoice Data Extraction" },
//         { icon: "/cross-pricisng-visible.svg", text: "AI RFP Response Writer" },
//         { icon: "/features-icon-one-icon.svg", text: "Support Level: Standard support included" },
//         {
//           icon: "/features-icon-seven-pay.svg",
//           text: (
//             <>
//               <span className="bg-gradient-to-r from-[#C95EBE] to-[#8B55DD] bg-clip-text text-transparent font-semibold mr-1">
//                 Coming Soon:
//               </span>
//               Custom Fields Extraction
//             </>
//           ),
//         },
//         {
//           icon: "/features-icon-seven-pay.svg",
//           text: (
//             <>
//               <span className="bg-gradient-to-r from-[#C95EBE] to-[#8B55DD] bg-clip-text text-transparent font-semibold mr-1">
//                 Coming Soon:
//               </span>
//               Includes Google Drive and OneDrive integrations
//             </>
//           ),
//         },
//       ],
//     },
//     {
//       offer: "Recommended",
//       title: "Grow",
//       planDes: "Yearly Plan - Saves more",
//       originalPrice: 299.99,
//       discountedPrice: 199.0,
//       priceUnit: "/year",
//       button: { text: "Start Free Trial" },
//       user: { logo: <img src={multiUser} alt="multi-user" />, text: "Multiple Users" },
//       points: [
//         {
//           icon: "/features-icon-two-icon.svg",
//           text: (
//             <>
//               <span>Document Upload Limit:</span> Unlimited
//             </>
//           ),
//         },
//         { icon: "/features-icon-two-icon.svg", text: "Daily Questions Limit: Unlimited" },
//         { icon: "/features-icon-two-icon.svg", text: "Maximum File Size: 50 MB" },
//         { icon: "/features-icon-two-icon.svg", text: "AI Co-Pilot with AI Search on Knowledgebase" },
//         {
//           icon: "/features-icon-two-icon.svg",
//           text: (
//             <>
//               <span>Multi-Document Chat:</span>
//               <br />
//               Chat with up to 10 documents simultaneously
//             </>
//           ),
//         },
//         { icon: "/features-icon-two-icon.svg", text: "Advanced Contracts & Invoice Data Extraction" },
//         { icon: "/features-icon-two-icon.svg", text: "Support Level: Standard support included" },
//         {
//           icon: "/cross-pricisng-visible-black.svg",
//           text: (
//             <>
//               <span className="text-[#F3904F] font-semibold mr-1">Coming Soon:</span>
//               Includes Google Drive and OneDrive integrations
//             </>
//           ),
//         },
//         {
//           icon: "/cross-pricisng-visible-black.svg",
//           text: (
//             <>
//               <span className="text-[#F3904F] font-semibold mr-1">Coming Soon:</span>
//               Custom Field Extraction
//             </>
//           ),
//         },
//       ],
//     },
//     {
//       offer: "Coming Soon",
//       title: "Enterprise",
//       planDes: "Ideal for Organisations",
//       originalPrice: null,
//       discountedPrice: null,
//       priceUnit: "",
//       button: { text: "Contact Sales" },
//       user: { logo: <img src={multiUser} alt="multi-user" />, text: "Multiple Users" },
//       points: [
//         { icon: "/features-icon-one-icon.svg", text: "Document Upload Limit: Everything on Grow" },
//         { icon: "/features-icon-one-icon.svg", text: "Advanced OCR ID Data Extraction" },
//         { icon: "/features-icon-one-icon.svg", text: "AI RFP Response Writer" },
//         { icon: "/features-icon-one-icon.svg", text: "Google Drive Integration" },
//         { icon: "/features-icon-one-icon.svg", text: "One Drive Integration" },
//         { icon: "/features-icon-one-icon.svg", text: "Custom field Extraction" },
//         { icon: "/features-icon-one-icon.svg", text: "SSO and SAML" },
//         { icon: "/features-icon-one-icon.svg", text: "Dedicated Customer Success Manager" },
//       ],
//     },
//   ];

//   const handleCardClick = (index) => setSelectedCard(index);

//   const fetchPlans = async () => {
//     try {
//       const response = await api.get(`api/v1/accounts/get-plans/`);
//       if (response.status === 200) {
//         const { ip_address, currency, country_code } = response.data;
//         setUserIP(ip_address);
//         setCountryCode(country_code);
//         setCurrencySymbol(currency === "INR" ? "₹" : "$");
//       }
//     } catch (error) {
//       console.error("Error fetching plans:", error);
//     }
//   };

//   useEffect(() => {
//     fetchPlans();
//   }, []);

//   const formatPopupDate = (dateObj) => {
//     if (!dateObj) return "";
//     const day = String(dateObj.getDate()).padStart(2, "0");
//     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const fetchSubscriptionStatus = async () => {
//     try {
//       const response = await api.get("api/v1/accounts/get-subscription-status/");
//       if (response.status === 200) {
//         const data = response.data;
//         setSubscriptionStatus(response.data);
//         if (
//           data?.subscription_type === "paid_subs" &&
//           (data?.plan_type === "yearly" || data?.plan_type === "monthly")
//         ) {
//           navigate("/ai-Copilot");
//           return;
//         }
//         if (
//           data?.subscription_type === "trial_expired" ||
//           response.data?.expired_or_cancelled_subscription?.subscription_type === "subscription_expired"
//         ) {
//           setHasCancelledOnce(true);
//         }
//         const { quota, plan_type } = data;
//         if (quota === "monthly" && plan_type === "trial") {
//           navigate("/ai-Copilot");
//           return;
//         }
//       }
//     } catch (error) {
//       if (error.response && error.response.data) {
//         const data = error.response.data;
//         if (data?.subscription_type === "trial_expired") setHasCancelledOnce(true);
//       }
//       console.error("Error fetching subscription status:", error);
//     }
//   };

//   useEffect(() => {
//     fetchSubscriptionStatus();
//   }, []);

//   const formatPrice = (usd, inr) => {
//     return currencySymbol === "₹" ? `₹${inr}` : `$${usd}`;
//   };

//   const handleSubscribe = async () => {
//     if (!selectedPlan) {
//       console.error("🚨 No plan selected");
//       return;
//     }

//     const planType = selectedPlan.title === "Grow" ? "yearly" : "monthly";
//     const headers = {};

//     if (
//       hasCancelledOnce &&
//       (selectedPlan.title === "Start" || selectedPlan.title === "Grow")
//     ) {
//       headers["X-Forwarded-For"] = userIP;
//       setIsProcessingPayment(true);

//       let attempts = 0;
//       const maxAttempts = 30;
//       const delay = 3000;

//       const pollForCheckoutUrl = async () => {
//         try {
//           const response = await api.post(
//             "api/v1/accounts/create-subscription/",
//             {
//               plan_type: planType,
//               currency: currencySymbol === "₹" ? "INR" : "USD",
//             },
//             { headers }
//           );

//           const { checkout_url } = response.data;

//           if (checkout_url) {
//             window.location.href = checkout_url;
//             return;
//           } else {
//             attempts++;
//             if (attempts < maxAttempts) {
//               setTimeout(pollForCheckoutUrl, delay);
//             } else {
//               throw new Error("Checkout URL not available after multiple attempts.");
//             }
//           }
//         } catch (error) {
//           console.error(`❌ Attempt ${attempts + 1} failed:`, error);
//           attempts++;
//           if (attempts < maxAttempts) {
//             setTimeout(pollForCheckoutUrl, delay);
//           } else {
//             alert(
//               error?.response?.data?.message ||
//                 error.message ||
//                 "Failed to create subscription after multiple attempts."
//             );
//             setIsProcessingPayment(false);
//           }
//         }
//       };

//       pollForCheckoutUrl();
//       return;
//     }

//     try {
//       setIsProcessingPayment(true);
//       const response = await api.post(
//         "api/v1/accounts/start-trial/",
//         { plan_type: planType },
//         { headers }
//       );
//       const data = response.data;

//       if (
//         data.message === "Trial started successfully" ||
//         data.message === "Trial already exists."
//       ) {
//         setIsPopupOpen(false);
//         setShowGetStarted(true);
//       } else {
//         throw new Error(data.message || "Unexpected response");
//       }
//     } catch (error) {
//       console.error("❌ Error starting trial:", error);
//       const errMessage =
//         error?.response?.data?.message || error.message || "Failed to start trial";
//       alert(errMessage);
//       setIsProcessingPayment(false);
//     }
//   };

//   // ---------- Helpers for per-card theming ----------
//   const isFeatured = (title) => title === "Grow";

//   const getButtonColor = (title) => (title === "Enterprise" ? "#C95EBE" : "#8B55DD");

//   const getOfferBadgeStyles = (title) => {
//     if (title === "Enterprise") {
//       return "bg-gradient-to-r from-[rgba(201,94,190,0.4)] to-[rgba(139,85,221,0.4)] text-[#8B55DD]";
//     }
//     if (title === "Grow") {
//       return "bg-white text-[#8B55DD]";
//     }
//     return "bg-[#ECE0FD] text-[#8B55DD]";
//   };

//   const getDisplayPrice = (card) => {
//     if (card.title === "Grow") {
//       return {
//         original: formatPrice(card.originalPrice, "25,675.30"),
//         discounted: formatPrice(card.discountedPrice, "17,032.00"),
//       };
//     }
//     return {
//       original: formatPrice(card.originalPrice, "5,219.96"),
//       discounted: formatPrice(card.discountedPrice, "3,338.00"),
//     };
//   };

//   const getPopupPrice = (title) => {
//     if (title === "Grow") {
//       return `${currencySymbol}${currencySymbol === "₹" ? "17,032.00" : "299.00"}`;
//     }
//     return `${currencySymbol}${currencySymbol === "₹" ? "3,338.00" : "39.00"}`;
//   };

//   return (
//     <div className="min-h-screen bg-[#FEF9F7]">
//       {/* Inline styles for things Tailwind cannot express without a plugin */}
//       <style>{`
//         .points-scroll::-webkit-scrollbar { width: 5px; }
//         .points-scroll::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.2); border-radius: 5px; }
//         .points-scroll::-webkit-scrollbar-track { background: transparent; }
//         .points-scroll-light::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.4); }
//         @keyframes pricingFadeIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
//         .pricing-fade-in { animation: pricingFadeIn 0.3s ease; }
//       `}</style>

//       {/* Sticky Header */}
//       <div className="w-full relative sticky top-0 z-[100] bg-white">
//         <Header image={docologo} name="" />
//         <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//           <span className="whitespace-nowrap text-base sm:text-lg md:text-xl font-semibold text-black">
//             Choose the best Plan for You
//           </span>
//         </div>
//       </div>

//       {/* Cards section */}
//       <div className="w-full px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
//         <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 items-stretch">
//           {cardInfo.map((card, index) => {
//             const featured = isFeatured(card.title);
//             const prices = getDisplayPrice(card);
//             const buttonColor = getButtonColor(card.title);
//             const ctaLabel =
//               hasCancelledOnce && (card.title === "Start" || card.title === "Grow")
//                 ? "Proceed"
//                 : card.button.text;

//             return (
//               <div
//                 key={card.title}
//                 onClick={() => handleCardClick(index)}
//                 className={`relative flex flex-col rounded-2xl border border-black/10 shadow-[0px_5px_15px_rgba(208,204,204,0.35)] p-6 transition-all duration-300 ${
//                   featured
//                     ? "bg-[#8B55DD] lg:-translate-y-6 lg:scale-[1.02] z-10"
//                     : "bg-white"
//                 }`}
//               >
//                 {/* Offer badge */}
//                 {card.offer && (
//                   <div
//                     className={`inline-flex items-center justify-center self-start px-3 py-1 text-[13px] font-medium font-['Outfit'] ${getOfferBadgeStyles(
//                       card.title
//                     )} ${
//                       card.title === "Start"
//                         ? "rounded-tl-2xl rounded-br-2xl -ml-6 -mt-6 px-4 py-1.5"
//                         : "rounded-md"
//                     }`}
//                   >
//                     {card.offer}
//                   </div>
//                 )}

//                 {/* Title + description */}
//                 <div className="text-center mt-4">
//                   <h3
//                     className={`text-2xl font-bold ${
//                       featured ? "text-white" : "text-[#18101C]"
//                     }`}
//                   >
//                     {card.title}
//                   </h3>
//                   <p
//                     className={`mt-1 text-[13px] font-bold font-['Outfit'] ${
//                       featured ? "text-white/90" : "text-[#8B55DD]"
//                     }`}
//                   >
//                     {card.planDes}
//                   </p>
//                 </div>

//                 {/* Price */}
//                 <div className=" text-center min-h-[40px] flex items-end justify-center">
//                   {card.originalPrice !== null ? (
//                     <div className="flex items-baseline justify-center gap-2 flex-wrap">
//                       <span
//                         className={`text-base font-normal line-through font-['Outfit'] ${
//                           featured ? "text-white/70" : "text-[#BB42AE]"
//                         }`}
//                       >
//                         {prices.original}
//                       </span>
//                       <span
//                         className={`text-3xl font-bold font-['Outfit'] ${
//                           featured ? "text-white" : "text-black"
//                         }`}
//                       >
//                         {prices.discounted}
//                       </span>
//                       <span
//                         className={`text-sm font-medium font-['Outfit'] ${
//                           featured ? "text-white/80" : "text-[#52525B]"
//                         }`}
//                       >
//                         {card.priceUnit}
//                       </span>
//                     </div>
//                   ) : (
//                     <span className="text-sm font-bold font-['Outfit'] text-[#52525B]">
//                       Coming Soon
//                     </span>
//                   )}
//                 </div>

//                 {/* Divider */}
//                 <div
//                   className="my-5 h-px w-full"
//                   style={{
//                     background: featured
//                       ? "linear-gradient(111deg, #F5EEFF 14.52%, #FDFDFD 99.31%)"
//                       : "linear-gradient(180deg, #C95EBE 0%, #8B55DD 100%)",
//                   }}
//                 />

//                 {/* What's Included pill */}
//                 <div
//                   className={`inline-flex items-center gap-1.5 self-start px-4 py-1.5 rounded-full ${
//                     featured
//                       ? "bg-gradient-to-br from-[#F5EEFF] to-[#FDFDFD]"
//                       : "bg-[rgba(187,66,174,0.24)]"
//                   }`}
//                 >
//                   <img
//                     src={featured ? "/black-star-pricisng.svg" : "/stars-pay.svg"}
//                     alt=""
//                     className="w-5 h-5"
//                   />
//                   <span
//                     className={`text-sm font-medium font-['Outfit'] tracking-[-0.28px] ${
//                       featured ? "text-[#171717]" : "text-[#BB42AE]"
//                     }`}
//                   >
//                     What's Included
//                   </span>
//                 </div>

//                 {/* Points list (scrollable, fills available space) */}
//                 <div
//                   className={`points-scroll ${
//                     featured ? "points-scroll-light" : ""
//                   } mt-4 flex-1 overflow-y-auto pr-2 flex flex-col gap-2.5 max-h-[260px] sm:max-h-[280px]`}
//                 >
//                   {card.points.map((point, pointIndex) => (
//                     <div key={pointIndex} className="flex items-start gap-3">
//                       <img
//                         src={point.icon}
//                         alt=""
//                         className="w-5 h-5 mt-0.5 shrink-0"
//                       />
//                       <div
//                         className={`text-[13px] leading-5 font-medium font-['Outfit'] ${
//                           featured ? "text-white" : "text-[#383838]"
//                         }`}
//                       >
//                         {point.text}
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 {/* CTA */}
//                 <button
//                   onClick={() => handleOpenPopup(card)}
//                   className="mt-6 w-full py-3 px-4 rounded-full font-bold text-base font-['Outfit'] flex items-center justify-center gap-2 transition-all duration-200 hover:opacity-90"
//                   style={{
//                     color: featured ? "#FFFFFF" : buttonColor,
//                     border: `2px solid ${featured ? "#FFFFFF" : buttonColor}`,
//                     backgroundColor: "transparent",
//                   }}
//                 >
//                   <span>{ctaLabel}</span>
//                   <img
//                     src={
//                       card.title === "Enterprise"
//                         ? "/call-new-icon.svg"
//                         : featured
//                         ? "/pay-icon-trail-whites.svg"
//                         : "/pay-icon-trail.svg"
//                     }
//                     alt=""
//                     className="w-5 h-5"
//                   />
//                 </button>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Confirmation popup */}
//       {isPopupOpen && (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
//           <div className="bg-white rounded-xl w-full max-w-[490px] relative shadow-[0px_10px_20px_rgba(0,0,0,0.2)] p-6">
//             <button
//               className="absolute top-3 right-4 text-2xl font-bold cursor-pointer leading-none text-[#52525B] hover:text-black"
//               onClick={handleClosePopup}
//               aria-label="Close"
//             >
//               &times;
//             </button>

//             <h2 className="text-[#52525B] font-['Outfit'] text-[13px] font-bold leading-normal pr-6">
//               {selectedPlan?.title === "Start"
//                 ? "Start Your 14-Day Free Trial Today!"
//                 : selectedPlan?.title === "Grow"
//                 ? "Confirm Your Plan Upgrade"
//                 : "Get Started with Your Plan"}
//             </h2>

//             <p className="mt-2 text-[#52525B] font-['Outfit'] text-[13px] font-medium leading-normal">
//               {selectedPlan?.title === "Grow"
//                 ? "You're upgrading to the full version of your plan. Enjoy all premium features!"
//                 : "Review your selection and start enjoying premium features right away"}
//             </p>

//             {/* Plan Details */}
//             <div className="mt-4 rounded-md border border-black/10 bg-[#FEF9F7] p-4">
//               <div className="flex justify-between flex-wrap gap-2 mb-3">
//                 <span className="rounded-tl-md rounded-br-[9px] text-[#8B55DD] text-center font-['Outfit'] text-xs font-medium tracking-[-0.24px] px-2 py-1 bg-[rgba(139,85,221,0.16)]">
//                   Free for 14-days
//                 </span>
//                 <span className="rounded-tl-md rounded-br-[9px] text-[#8B55DD] text-center font-['Outfit'] text-xs font-medium tracking-[-0.24px] px-2 py-1 bg-[rgba(139,85,221,0.16)]">
//                   Billed {selectedPlan?.title === "Grow" ? "yearly" : "monthly"}
//                 </span>
//               </div>

//               <div className="grid grid-cols-2 gap-y-3 gap-x-6 text-left">
//                 <div>
//                   <p className="text-[#52525B] font-['Outfit'] text-[13px] font-bold">Plan</p>
//                   <p className="text-[#18101C] font-['Outfit'] text-sm font-medium mt-1">
//                     {selectedPlan?.title} Plan
//                   </p>
//                 </div>
//                 <div>
//                   <p className="text-[#52525B] font-['Outfit'] text-[13px] font-bold">Price</p>
//                   <p className="text-[#18101C] font-['Outfit'] text-sm font-medium mt-1">
//                     {getPopupPrice(selectedPlan?.title)}
//                     <sub>{selectedPlan?.title === "Grow" ? "/year" : "/month"}</sub>
//                   </p>
//                 </div>
//                 <div>
//                   <p className="text-[#52525B] font-['Outfit'] text-[13px] font-bold">Start Date</p>
//                   <p className="text-[#18101C] font-['Outfit'] text-sm font-medium mt-1">
//                     {formatPopupDate(upgradeStartDate)}
//                   </p>
//                 </div>
//                 <div>
//                   <p className="text-[#52525B] font-['Outfit'] text-[13px] font-bold">End Date</p>
//                   <p className="text-[#18101C] font-['Outfit'] text-sm font-medium mt-1">
//                     {formatPopupDate(upgradeEndDate)}
//                   </p>
//                 </div>
//               </div>

//               <p className="mt-3 text-[13px] text-[#73607B] leading-tight">
//                 {hasCancelledOnce
//                   ? "You're just a step away from reactivating your premium features. No trial — direct activation on secure payment."
//                   : "No payment or card required to start the trial. Just click below and begin exploring DocuSensa's premium features!"}
//               </p>
//             </div>

//             <p className="mt-3 text-[#171717] font-['Outfit'] text-[13px] font-medium">
//               By clicking below, you agree to our <strong>Terms of Service</strong> and{" "}
//               <strong>Privacy Policy</strong>.
//             </p>

//             <button
//               type="button"
//               disabled={isProcessingPayment}
//               onClick={!isProcessingPayment ? handleSubscribe : undefined}
//               className={`mt-3 w-full flex flex-col items-center justify-center bg-[#8B55DD] hover:bg-[#7a45cc] text-white rounded-md py-3 px-5 transition-colors ${
//                 isProcessingPayment ? "opacity-60 pointer-events-none cursor-not-allowed" : "cursor-pointer"
//               }`}
//             >
//               <span className="text-[#F5F4F3] font-['Outfit'] text-base font-semibold">
//                 {isProcessingPayment
//                   ? hasCancelledOnce
//                     ? "Please wait ⏳ Redirecting to Stripe..."
//                     : "Please wait ⏳ Redirecting to Docusensa..."
//                   : hasCancelledOnce
//                   ? "Proceed to Secure Payment"
//                   : "Start Free Trial Now"}
//               </span>
//               <span className="text-white/80 font-['Outfit'] text-xs font-normal mt-0.5">
//                 {hasCancelledOnce
//                   ? "Your card will be charged immediately to activate your subscription."
//                   : "You'll be redirected to Docusensa to start your 14 days trial."}
//               </span>
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Activation in progress popup */}
//       {isActivating && (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
//           <div className="relative w-full max-w-[600px]">
//             <img
//               src="/leftside-celebration.svg"
//               alt=""
//               className="hidden lg:block absolute -left-32 top-1/2 -translate-y-1/2 z-0 pointer-events-none"
//             />
//             <img
//               src="/right-side-celebration.svg"
//               alt=""
//               className="hidden lg:block absolute -right-32 top-1/2 -translate-y-1/2 z-0 pointer-events-none"
//             />
//             <div className="relative z-10 px-8 py-10 text-center w-full rounded-xl bg-white shadow-[9px_15px_37px_0px_rgba(0,0,0,0.10)] pricing-fade-in">
//               <img src="/celebrate-icon.svg" alt="" className="h-10 mx-auto" />
//               <h2 className="mt-3 text-[#18101C] font-['Outfit'] text-xl font-semibold tracking-[0.2px]">
//                 Welcome on board!
//               </h2>
//               <p className="mt-2 text-[#3F3F46] font-['Outfit'] text-sm font-medium leading-5 tracking-[0.14px]">
//                 ✨ We're setting up your premium features...
//                 <br />
//                 Hang tight, this will take just a moment!
//               </p>
//               <button
//                 disabled
//                 className="mt-4 inline-flex py-2.5 px-7 justify-center items-center gap-2.5 rounded-lg opacity-75 bg-gradient-to-r from-[#6F52ED] to-[#845EC2] text-white font-['Outfit'] text-sm font-medium leading-5 tracking-[0.14px] cursor-wait"
//               >
//                 Activating your account
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Activation complete popup */}
//       {showGetStarted &&
//         (() => {
//           setTimeout(() => {
//             setShowGetStarted(false);
//             navigate("/ai-Copilot");
//           }, 3000);

//           return (
//             <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
//               <div className="relative w-full max-w-[600px]">
//                 <img
//                   src="/leftside-celebration.svg"
//                   alt=""
//                   className="hidden lg:block absolute -left-32 top-1/2 -translate-y-1/2 z-0 pointer-events-none"
//                 />
//                 <img
//                   src="/right-side-celebration.svg"
//                   alt=""
//                   className="hidden lg:block absolute -right-32 top-1/2 -translate-y-1/2 z-0 pointer-events-none"
//                 />
//                 <div className="relative z-10 px-8 py-10 text-center w-full rounded-xl bg-white shadow-[9px_15px_37px_0px_rgba(0,0,0,0.10)] pricing-fade-in">
//                   <img src="/celebrate-icon.svg" alt="" className="h-10 mx-auto" />
//                   <h2 className="mt-3 text-[#18101C] font-['Outfit'] text-xl font-semibold tracking-[0.2px]">
//                     You're all set!
//                   </h2>
//                   <p className="mt-2 text-[#3F3F46] font-['Outfit'] text-sm font-medium leading-5 tracking-[0.14px]">
//                     Ready to unlock the full potential of your documents?
//                     <br />
//                     Your 14-day free trial starts now!
//                   </p>
//                   <button
//                     className="mt-4 inline-flex py-2.5 px-7 justify-center items-center gap-2.5 rounded-lg bg-gradient-to-r from-[#6F52ED] to-[#845EC2] text-white font-['Outfit'] text-sm font-medium leading-5 tracking-[0.14px] hover:opacity-90 transition-opacity"
//                     onClick={() => {
//                       setShowGetStarted(false);
//                       window.location.href = "/ai-Copilot";
//                     }}
//                   >
//                     Get Started Now
//                   </button>
//                 </div>
//               </div>
//             </div>
//           );
//         })()}
//     </div>
//   );
// };

// export default Pricing;

import React, { useState, useEffect } from "react";
import { BsArrowRight } from "react-icons/bs";
import axios from "axios";
import { IoMdContacts } from "react-icons/io";
import { TiTick } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import singleUser from "../../Images/single-user.png";
import multiUser from "../../Images/group.png";
import leftArrow from "../../Images/arrow_cool_down.jpg";
import notificaton from "../../Images/notifications.jpg";
import docologo from "../../Images/doculogo.svg";
import cardCheck from "../../Images/card-check.jpg";
import { Header } from "../../components/Header/Header";
import Cookies from "js-cookie";
import api from "../chat/api";
import {
  getCachedSubscriptionStatus,
  setCachedSubscriptionStatus,
} from "../../utils/subscriptionStatus";

const Pricing = () => {
  const [isMonthly, setIsMonthly] = useState(true);
  const [subscriptionId, setSubscriptionId] = useState(null);

  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(null);
  const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [isActivating, setIsActivating] = useState(false);
  const [showGetStarted, setShowGetStarted] = useState(false);

  const handleOpenPopup = (plan) => {
    if (plan.title === "Enterprise") {
      window.open("https://docusensa.com/contact-us", "_blank");
      return;
    }
    setSelectedPlan(plan);
    setIsProcessingPayment(false);
    const start = new Date();
    const end = new Date(start);

    if (plan.title === "Grow") {
      end.setFullYear(end.getFullYear() + 1);
    } else {
      end.setMonth(end.getMonth() + 1);
    }

    setUpgradeStartDate(start);
    setUpgradeEndDate(end);
    setIsPopupOpen(true);
    setSubscriptionId(null);
  };

  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [countryCode, setCountryCode] = useState("");
  const [hasCancelledOnce, setHasCancelledOnce] = useState(false);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const initializeRazorpay = async (subscriptionId) => {
    const isScriptLoaded = await loadRazorpayScript();
    if (!isScriptLoaded || !subscriptionId) return;

    const userName = localStorage.getItem("fullName") || "User";
    const userEmail = localStorage.getItem("email") || "user@example.com";
    const userContact = localStorage.getItem("user_contact") || "0000000000";

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_live_aCWZouiI1r4JJE",
      subscription_id: subscriptionId,
      name: "DocuSensa",
      description: `${selectedPlan?.title} Plan Subscription`,
      image: "/DocuSensaLogo.png",
      callback_url: window.location.origin + "/ai-Copilot",
      prefill: { name: userName, email: userEmail, contact: userContact },
      theme: { color: "#C95EBE" },
      config: { display: { preferences: { show_default_blocks: false } } },
      handler: async function (response) {
        const token = localStorage.getItem("token");
        const prevSubType = subscriptionStatus?.subscription_type;
        const prevPlanType = subscriptionStatus?.plan_type;
        let retryCount = 0;
        setIsActivating(true);
        const pollSubscription = async () => {
          try {
            const result = await api.get(`api/v1/accounts/get-subscription-status/`);
            if (result.status === 200) setCachedSubscriptionStatus(result.data);
            const { subscription_type, plan_type, quota, message } = result.data;
            const isNowPaid = subscription_type === "paid_subs";
            const upgraded =
              (prevSubType === "trial" && plan_type === "yearly") ||
              (prevSubType === "trial" && plan_type === "monthly") ||
              (prevSubType === "paid_subs" &&
                prevPlanType === "monthly" &&
                plan_type === "yearly");

            const shouldNavigate =
              subscription_type === "trial" &&
              (quota === "monthly" || quota === "yearly") &&
              !plan_type.includes("paid_subs");

            if (shouldNavigate || message) {
              setIsActivating(false);
              setShowGetStarted(true);
              return;
            }

            retryCount++;
            if (retryCount < 30) {
              setTimeout(pollSubscription, 4000);
            } else {
              console.warn("⏱ Max retries reached. Manual refresh might be required.");
            }
          } catch (err) {
            console.error("❌ Polling error:", err);
            retryCount++;
            if (retryCount < 30) {
              setTimeout(pollSubscription, 4000);
            }
          }
        };

        setTimeout(() => {
          pollSubscription();
        }, 10000);
      },
      modal: {
        escape: false,
        ondismiss: function () {},
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const token = localStorage.getItem("token");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedPlan(null);
    setIsProcessingPayment(false);
  };

  const cardInfo = [
    {
      offer: "Limited Time Offer",
      title: "Start",
      planDes: "Monthly Plan - Flexible & Affordable",
      originalPrice: 60.99,
      discountedPrice: 39.0,
      button: { text: "Proceed" },
      user: { logo: <img src={singleUser} alt="user" />, text: "1 user" },
      purchaseText: "Start Free Trial",
      points: [
        {
          icon: "/features-icon-one-icon.svg",
          text: (
            <>
              <span className="font-semibold text-[#383838]">Document Upload Limit:</span>
              <br />
              Upto 70 documents per month
            </>
          ),
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "Daily Questions Limit: Unlimited",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "Maximum File Size: 25 MB",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "AI Co-Pilot with AI Search on Knowledgebase",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: (
            <>
              <span className="font-semibold text-[#383838]">Multi-Document Chat:</span>
              <br />
              Chat with up to 5 documents simultaneously
            </>
          ),
        },
        {
          icon: "/cross-pricisng-visible.svg",
          text: <span className="font-semibold text-[#383838]">Advanced OCR ID Data Extraction.</span>,
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "Advanced Contracts & Invoice Data Extraction ",
        },
        {
          icon: "/cross-pricisng-visible.svg",
          text: <span className="font-semibold text-[#383838]">AI RFP Response Writer</span>,
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "Support Level: Standard support included",
        },
        {
          icon: "/features-icon-seven-pay.svg",
          text: (
            <>
              <span className="bg-[linear-gradient(90deg,#C95EBE_2.53%,#8B55DD_23.14%)] bg-clip-text text-transparent [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">Coming Soon:</span> Custom Fields Extraction
            </>
          ),
        },
        {
          icon: "/features-icon-seven-pay.svg",
          text: (
            <>
              <span className="bg-[linear-gradient(90deg,#C95EBE_2.53%,#8B55DD_23.14%)] bg-clip-text text-transparent [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">Coming Soon:</span> Includes Google Drive and OneDrive integrations
            </>
          ),
        },
      ],
    },
    {
      offer: "Recommended",
      title: "Grow",
      planDes: "Yearly Plan - Saves more",
      originalPrice: 299.99,
      discountedPrice: 199.0,
      button: { text: "Proceed" },
      user: { logo: <img src={multiUser} alt="multi-user" />, text: "Multiple Users" },
      purchaseText: "Purchase Pro",
      points: [
        {
          icon: "/features-icon-two-icon.svg",
          text: (
            <>
              <span className="font-semibold text-[#383838] text-white">Document Upload Limit:</span> Unlimited
            </>
          ),
        },
        {
          icon: "/features-icon-two-icon.svg",
          text: "Daily Questions Limit: Unlimited",
        },
        {
          icon: "/features-icon-two-icon.svg",
          text: "Maximum File Size: 50 MB",
        },
        {
          icon: "/features-icon-two-icon.svg",
          text: "AI Co-Pilot with AI Search on Knowledgebase",
        },
        {
          icon: "/features-icon-two-icon.svg",
          text: (
            <>
              <span className="font-semibold text-[#383838] text-white">Multi-Document Chat:</span>
              <br />
              Chat with up to 10 documents simultaneously
            </>
          ),
        },
        {
          icon: "/features-icon-two-icon.svg",
          text: "Advanced Contracts & Invoice Data Extraction ",
        },
        {
          icon: "/features-icon-two-icon.svg",
          text: "Support Level: Standard support included",
        },
        {
          icon: "/cross-pricisng-visible-black.svg",
          text: (
            <>
              <span className="bg-[#F3904F] bg-clip-text text-transparent font-outfit text-[13px] font-semibold text-white [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">Coming Soon:</span> Includes Google Drive and OneDrive integrations
            </>
          ),
        },
        {
          icon: "/cross-pricisng-visible-black.svg",
          text: (
            <>
              <span className="bg-[#F3904F] bg-clip-text text-transparent font-outfit text-[13px] font-semibold text-white [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">Coming Soon:</span> Custom Field Extraction
            </>
          ),
        },
      ],
    },
    {
      offer: "Coming Soon",
      title: "Enterprise",
      planDes: "Ideal for Organisations",
      originalPrice: null,
      discountedPrice: "",
      button: { text: "Contact Sales" },
      user: { logo: <img src={multiUser} alt="multi-user" />, text: "Multiple Users" },
      purchaseText: "Contact Sales",
      points: [
        {
          icon: "/features-icon-one-icon.svg",
          text: <span className="font-semibold text-[#383838]">Document Upload Limit:Everything on Grow</span>,
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "Advanced OCR ID Data Extraction:",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "AI RFP Response Writer",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "Google Drive Integration",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "One Drive Integration",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "Custom field Extraction",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "SSO and SAML",
        },
        {
          icon: "/features-icon-one-icon.svg",
          text: "Dedicated Customer Success Manager",
        },
      ],
    },
  ];

  const handlePaymentFrequencyChange = (frequency) => {
    setIsMonthly(frequency);
  };

  const handleCardClick = (index) => {
    setSelectedCard(index);
  };

  const getBackgroundColor = (title) => {
    switch (title) {
      case "Start": return "#ECE0FD";
      case "Grow": return "rgba(201, 94, 190, 0.20)";
      case "Enterprise": return "#ECE0FD";
      default: return "white";
    }
  };

  const getTextColor = (title) => {
    switch (title) {
      case "Start": return "#8B55DD";
      case "Grow": return "#C95EBE";
      case "Enterprise": return "linear-gradient(90deg, #8B55DD 0%, #8B55DD 100%)";
      default: return "white";
    }
  };

  const getButtonColor = (title) => {
    switch (title) {
      case "Start": return "#8B55DD";
      case "Grow": return "#FFF";
      case "Enterprise": return "#C95EBE";
      default: return "black";
    }
  };

  const getButtonBorderColor = (title) => {
    switch (title) {
      case "Start": return "#8B55DD";
      case "Grow": return "#FFF";
      case "Enterprise": return "#C95EBE";
      default: return "black";
    }
  };

  const handleNavigation = () => {
    navigate("/ai-Copilot");
  };

  const getLink = () => {
    return isMonthly
      ? "https://rzp.io/rzp/docusensa-testing"
      : "https://pages.razorpay.com/pl_PBk8xMY3wOv18X/view";
  };

  const [plans, setPlans] = useState([]);
  const [userIP, setUserIP] = useState("103.108.4.82");

  const fetchPlans = async () => {
    try {
      const response = await api.get(`api/v1/accounts/get-plans/`);
      if (response.status === 200) {
        const { ip_address, currency, country_code } = response.data;
        setUserIP(ip_address);
        setCountryCode(country_code);

        if (currency === "INR") {
          setCurrencySymbol("₹");
        } else {
          setCurrencySymbol("$");
        }
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const [upgradeStartDate, setUpgradeStartDate] = useState(null);
  const [upgradeEndDate, setUpgradeEndDate] = useState(null);

  const formatPopupDate = (dateObj) => {
    if (!dateObj) return "";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [subscriptionStatus, setSubscriptionStatus] = useState(null);

  const fetchSubscriptionStatus = async () => {
    try {
      const cached = getCachedSubscriptionStatus();
      const response = cached
        ? { data: cached, status: 200 }
        : await api.get("api/v1/accounts/get-subscription-status/");
      if (!cached && response.status === 200) {
        setCachedSubscriptionStatus(response.data);
      }
      if (response.status === 200) {
        const data = response.data;
        setSubscriptionStatus(response.data);
        if (
          data?.subscription_type === "paid_subs" &&
          (data?.plan_type === "yearly" || data?.plan_type === "monthly")
        ) {
          navigate("/ai-Copilot");
          return;
        }
        if (
          data?.subscription_type === "trial_expired" ||
          response.data?.expired_or_cancelled_subscription?.subscription_type === "subscription_expired"
        ) {
          setHasCancelledOnce(true);
        }
        const { quota, plan_type } = data;
        if (quota === "monthly" && plan_type === "trial") {
          navigate("/ai-Copilot");
          return;
        }
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const data = error.response.data;
        if (data?.subscription_type === "trial_expired") {
          setHasCancelledOnce(true);
        }
      }
      console.error("Error fetching subscription status:", error);
    }
  };

  useEffect(() => {
    fetchSubscriptionStatus();
  }, []);

  const formatPrice = (usd, inr) => {
    return currencySymbol === "₹" ? `₹${inr}` : `$${usd}`;
  };

  const handleSubscribe = async () => {
    if (!selectedPlan) {
      console.error("🚨 No plan selected");
      return;
    }

    const planType = selectedPlan.title === "Grow" ? "yearly" : "monthly";
    const headers = {};

    if (
      hasCancelledOnce &&
      (selectedPlan.title === "Start" || selectedPlan.title === "Grow")
    ) {
      headers["X-Forwarded-For"] = userIP;
      setIsProcessingPayment(true);

      let attempts = 0;
      const maxAttempts = 30;
      const delay = 3000;

      const pollForCheckoutUrl = async () => {
        try {
          const response = await api.post(
            "api/v1/accounts/create-subscription/",
            {
              plan_type: planType,
              currency: currencySymbol === "₹" ? "INR" : "USD",
            },
            { headers }
          );

          const { checkout_url } = response.data;

          if (checkout_url) {
            window.location.href = checkout_url;
            return;
          } else {
            attempts++;
            if (attempts < maxAttempts) {
              setTimeout(pollForCheckoutUrl, delay);
            } else {
              throw new Error("Checkout URL not available after multiple attempts.");
            }
          }
        } catch (error) {
          console.error(`❌ Attempt ${attempts + 1} failed:`, error);
          attempts++;
          if (attempts < maxAttempts) {
            setTimeout(pollForCheckoutUrl, delay);
          } else {
            alert(
              error?.response?.data?.message ||
                error.message ||
                "Failed to create subscription after multiple attempts."
            );
            setIsProcessingPayment(false);
          }
        }
      };

      pollForCheckoutUrl();
      return;
    }

    try {
      setIsProcessingPayment(true);

      const response = await api.post(
        "api/v1/accounts/start-trial/",
        { plan_type: planType },
        { headers }
      );

      const data = response.data;

      if (
        data.message === "Trial started successfully" ||
        data.message === "Trial already exists."
      ) {
        setIsPopupOpen(false);
        setShowGetStarted(true);
      } else {
        throw new Error(data.message || "Unexpected response");
      }
    } catch (error) {
      console.error("❌ Error starting trial:", error);
      const errMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to start trial";
      alert(errMessage);
      setIsProcessingPayment(false);
    }
  };

  return (
    <div className="bg-[#FEF9F7] min-h-screen font-outfit">
      <div className="w-full sticky top-0 z-[100] bg-white">
        <Header image={docologo} name="" />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span className="whitespace-nowrap text-lg font-semibold text-black md:text-xl font-outfit text-center">
            Choose the best Plan for You
          </span>
        </div>
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 py-8 md:py-12">
        <div className="flex flex-col lg:flex-row items-stretch justify-center gap-6 lg:gap-8">
          {cardInfo.map((card, index) => (
            <div
              key={index}
              onClick={() => handleCardClick(index)}
              className="flex flex-col flex-1 min-w-[300px] w-full py-4 px-5  transition-all duration-300 shadow-[0_5px_15px_rgba(208,204,204,0.35)] rounded-2xl relative cursor-pointer hover:shadow-[0_8px_25px_rgba(139,85,221,0.2)]"
              style={{
                backgroundColor: index === 1 ? "#8B55DD" : "white",
                transform: index === 1 ? "scale(1.02)" : "scale(1)",
                zIndex: index === 1 ? 10 : 1,
              }}
            >
              {index !== 0 && (
                <div
                  className="absolute top-0 left-0 rounded-tl-2xl rounded-br-2xl text-[14px] font-medium font-outfit px-4 py-1 flex items-center justify-center"
                  style={
                    index === 2
                      ? {
                          background: "linear-gradient(91deg, rgba(201, 94, 190, 0.20) 16.63%, rgba(139, 85, 221, 0.20) 83.27%)",
                          color: "#8B55DD",
                        }
                      : { background: "#FFFFFF", color: "#8B55DD" }
                  }
                >
                  {card.offer}
                </div>
              )}

              <div className="flex flex-col items-center justify-center text-center mt-6 mb-4">
                <h3
                  className="text-2xl font-bold font-outfit"
                  style={{ color: index === 1 ? "#FFF" : "#18101C" }}
                >
                  {card.title}
                </h3>
                <p
                  className="text-center font-outfit text-[14px] font-bold mt-2"
                  style={{ color: index === 1 ? "#FFF" : "#8B55DD" }}
                >
                  {card.planDes}
                </p>
              </div>

              <div className="flex items-center justify-center gap-3 text-center mb-6">
                {card.originalPrice !== null ? (
                  <>
                    <span
                      className="font-outfit text-[16px] font-normal line-through"
                      style={{ color: index === 1 ? "rgba(255,255,255,0.7)" : "#BB42AE" }}
                    >
                      {formatPrice(
                        card.originalPrice,
                        card.title === "Grow" ? "25,675.30" : "5,219.96"
                      )}
                    </span>
                    <span
                      className="font-outfit text-3xl font-bold"
                      style={{ color: index === 1 ? "#FFF" : "black" }}
                    >
                      {formatPrice(
                        card.discountedPrice,
                        card.title === "Grow" ? "17,032.00" : "3,338.00"
                      )}
                    </span>
                    <sub
                      className="font-outfit text-[14px] font-medium bottom-0"
                      style={{ color: index === 1 ? "rgba(255,255,255,0.9)" : "#52525B" }}
                    >
                      {card.title === "Grow" ? "/year" : "/month"}
                    </sub>
                  </>
                ) : (
                  <span className="text-[#52525B] text-center font-outfit text-[15px] font-bold w-full">/Coming Soon</span>
                )}
              </div>

              <div
                className="w-full h-[1px] mb-6"
                style={{
                  background: index === 1
                    ? "linear-gradient(111deg, rgba(245,238,255,0.5) 14.52%, rgba(253,253,253,0.5) 99.31%)"
                    : "linear-gradient(180deg, rgba(201,94,190,0.3) 0%, rgba(139,85,221,0.3) 100%)",
                }}
              ></div>

              <div className="flex flex-col flex-grow gap-4">
                <div
                  className="inline-flex py-1.5 px-4 w-fit gap-2 rounded-full mx-auto"
                  style={{
                    background: index === 1
                      ? "white"
                      : "rgba(187, 66, 174, 0.12)",
                  }}
                >
                  <img 
                    src={index === 1 ? "/black-star-pricisng.svg" : "/stars-pay.svg"} 
                    alt="star icon" 
                    className="w-4 h-4 object-contain" 
                  />
                  <h4
                    className="font-outfit text-[14px] font-medium m-0 tracking-tight"
                    style={{ color: index === 1 ? "#8B55DD" : "#BB42AE" }}
                  >
                    What's Included
                  </h4>
                </div>

                <div className="mt-4 overflow-y-auto pr-2 flex flex-col gap-4 scrollbar-thin scrollbar-thumb-black/20 scrollbar-track-transparent flex-grow h-[280px]">
                  {card.points.map((point, pointIndex) => (
                    <div key={pointIndex} className="flex items-start text-sm w-full">
                      <img 
                        src={index === 1 ? "/features-icon-two-icon.svg" : point.icon} 
                        alt="feature icon" 
                        className="w-5 h-5 mr-3 mt-0.5 shrink-0" 
                      />
                      <div
                        className="font-outfit text-[14px] font-medium leading-relaxed"
                        style={{ color: index === 1 ? "#FFF" : "#383838" }}
                      >
                        {point.text}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-6 pt-4 w-full">
                <button
                  className="w-full py-3.5 rounded-full transition duration-300 flex items-center justify-center gap-2 text-center text-[16px] font-bold"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenPopup(card);
                  }}
                  style={{
                    color: getButtonColor(card.title),
                    border: index === 1 ? "2px solid #FFF" : `2px solid ${getButtonBorderColor(card.title)}`,
                    backgroundColor: "transparent"
                  }}
                >
                  <span className="flex items-center gap-2" style={{ color: index === 1 ? "#FFF" : "" }}>
                    {hasCancelledOnce && (card.title === "Start" || card.title === "Grow")
                      ? "Proceed"
                      : card.button.text}
                    <img
                      src={index === 2 ? "/call-new-icon.svg" : index === 1 ? "/pay-icon-trail-whites.svg" : "/pay-icon-trail.svg"}
                      alt="icon"
                      className="w-5 h-5"
                    />
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isPopupOpen && (
        <div className="fixed inset-0 z-[1000] bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-xl w-full max-w-[490px] relative shadow-2xl p-6 md:p-8">
            <span className="absolute top-4 right-4 text-2xl font-bold cursor-pointer text-gray-500 hover:text-black transition" onClick={handleClosePopup}>
              &times;
            </span>

            <h2 className="text-[#52525B] font-outfit text-lg font-bold mb-2">
              {selectedPlan === "Start"
                ? "Start Your 14-Day Free Trial Today!"
                : selectedPlan === "Grow"
                ? "Confirm Your Plan Upgrade"
                : "Get Started with Your Plan"}
            </h2>

            <p className="text-[#52525B] font-outfit text-sm font-medium mb-6">
              {selectedPlan === "Grow"
                ? "You're upgrading to the full version of your plan. Enjoy all premium features!"
                : "Review your selection and start enjoying premium features right away"}
            </p>

            <div className="w-full rounded-lg border border-black/10 bg-[#FEF9F7] overflow-hidden">
              <div className="flex justify-between text-sm font-bold border-b border-black/5">
                <span className="text-[#8B55DD] text-center font-outfit text-xs font-medium px-4 py-2 bg-[#8B55DD]/10 rounded-br-lg">
                  Free for 14-days
                </span>
                <span className="text-[#8B55DD] text-center font-outfit text-xs font-medium px-4 py-2 bg-[#8B55DD]/10 rounded-bl-lg">
                  Billed monthly
                </span>
              </div>
              <div className="p-4">
                <div className="grid grid-cols-2 gap-4 text-left w-full">
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-500 mb-1">Plan</p>
                    <p className="text-[#18101C] font-outfit text-sm font-medium">{selectedPlan?.title} Plan</p>
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-500 mb-1">Price</p>
                    <p className="text-[#18101C] font-outfit text-sm font-medium">
                      {selectedPlan?.title === "Grow"
                        ? `${currencySymbol}${currencySymbol === "₹" ? "17,032.00" : "299.00"}`
                        : `${currencySymbol}${currencySymbol === "₹" ? "3,338.00" : "39.00"}`}
                      <sub className="text-gray-500 font-normal">/month</sub>
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-500 mb-1">Start Date</p>
                    <p className="text-[#18101C] font-outfit text-sm font-medium">{formatPopupDate(upgradeStartDate)}</p>
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-500 mb-1">End Date</p>
                    <p className="text-[#18101C] font-outfit text-sm font-medium">{formatPopupDate(upgradeEndDate)}</p>
                  </div>
                </div>
                <p className="text-xs text-[#73607B] mt-4 leading-relaxed">
                  {hasCancelledOnce
                    ? "You're just a step away from reactivating your premium features. No trial — direct activation on secure payment."
                    : `No payment or card required to start the trial. Just click below and begin exploring DocuSensa’s premium features!`}
                </p>
              </div>
            </div>

            <p className="text-[#171717] font-outfit text-xs font-medium mt-6 mb-4 text-center">
              By clicking below, you agree to our <strong>Terms of Service</strong> and <strong>Privacy Policy</strong>.
            </p>
            
            <button
              className={`w-full py-4 rounded-lg bg-[#8B55DD] hover:bg-[#7a45cc] transition text-white flex flex-col items-center justify-center ${
                isProcessingPayment ? "opacity-60 pointer-events-none cursor-not-allowed" : ""
              }`}
              onClick={!isProcessingPayment ? handleSubscribe : undefined}
            >
              <span className="font-outfit text-base font-semibold mb-1">
                {isProcessingPayment
                  ? hasCancelledOnce
                    ? "Please wait ⏳ Redirecting to Stripe..."
                    : "Please wait ⏳ Redirecting to Docusensa..."
                  : hasCancelledOnce
                  ? "Proceed to Secure Payment"
                  : "Start Free Trial Now"}
              </span>
              <span className="font-outfit text-xs opacity-80 font-normal">
                {hasCancelledOnce
                  ? "Your card will be charged immediately to activate your subscription."
                  : "You’ll be redirected to Docusensa to start your 14 days trial."}
              </span>
            </button>
          </div>
        </div>
      )}

      {isActivating && (
        <div className="fixed inset-0 z-[1000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <img
            src="/leftside-celebration.svg"
            alt="celebration left"
            style={{ position: "absolute", top: "50%", left: "32rem", transform: "translateY(-50%)", zIndex: 1 }}
          />
          <img
            src="/right-side-celebration.svg"
            alt="celebration right"
            style={{ position: "absolute", top: "50%", left: "49rem", transform: "translateY(-50%)", zIndex: 1 }}
          />
          <div className="p-[2rem_2rem_2.5rem] text-center w-[600px] h-[240px] rounded-[12px] bg-white shadow-[219px_363px_119px_0px_rgba(0,0,0,0.00),140px_232px_108px_0px_rgba(0,0,0,0.01),79px_131px_91px_0px_rgba(0,0,0,0.05),35px_58px_68px_0px_rgba(0,0,0,0.09),9px_15px_37px_0px_rgba(0,0,0,0.10)] animate-[fadeIn_0.3s_ease] z-10 relative">
            <img src="/celebrate-icon.svg" alt="confetti" className="h-[40px] mx-auto" />
            <h2 className="text-[#18101C] text-center font-outfit text-[20px] font-semibold leading-[19px] tracking-[0.2px] mt-4">
              Welcome on board!
            </h2>
            <p className="mt-[0.6rem] text-[#3F3F46] text-center font-outfit text-[14px] font-medium leading-[19px] tracking-[0.14px]">
              ✨ We’re setting up your premium features...
              <br />
              Hang tight, this will take just a moment!
            </p>
            <button disabled className="inline-flex py-[10px] px-[28px] justify-center items-center gap-[10px] rounded-[8px] opacity-72 bg-[linear-gradient(93deg,#6F52ED_0.64%,#845EC2_99.52%)] mt-[1rem] text-white text-center font-outfit text-[14px] font-medium leading-[19px] tracking-[0.14px] bg-[#c4b5fd] cursor-wait">
              <span>Activating your account</span>
            </button>
          </div>
        </div>
      )}

      {showGetStarted && (
        (() => {
          setTimeout(() => {
            setShowGetStarted(false);
            navigate("/ai-Copilot");
          }, 3000);

          return (
            <div className="fixed inset-0 z-[1000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
              <img
                src="/leftside-celebration.svg"
                alt="celebration left"
                style={{ position: "absolute", top: "50%", left: "32rem", transform: "translateY(-50%)", zIndex: 1 }}
              />
              <img
                src="/right-side-celebration.svg"
                alt="celebration right"
                style={{ position: "absolute", top: "50%", left: "49rem", transform: "translateY(-50%)", zIndex: 1 }}
              />
              <div className="p-[2rem_2rem_2.5rem] text-center w-[600px] h-[240px] rounded-[12px] bg-white shadow-[219px_363px_119px_0px_rgba(0,0,0,0.00),140px_232px_108px_0px_rgba(0,0,0,0.01),79px_131px_91px_0px_rgba(0,0,0,0.05),35px_58px_68px_0px_rgba(0,0,0,0.09),9px_15px_37px_0px_rgba(0,0,0,0.10)] animate-[fadeIn_0.3s_ease] z-10 relative">
                <img src="/celebrate-icon.svg" alt="confetti" className="h-[40px] mx-auto" />
                <h2 className="text-[#18101C] text-center font-outfit text-[20px] font-semibold leading-[19px] tracking-[0.2px] mt-4">
                  You're all set!
                </h2>
                <p className="mt-[0.6rem] text-[#3F3F46] text-center font-outfit text-[14px] font-medium leading-[19px] tracking-[0.14px]">
                  Ready to unlock the full potential of your documents?
                  <br />
                  Your 14-day free trial starts now!
                </p>
                <button
                  className="inline-flex py-[10px] px-[28px] justify-center items-center gap-[10px] rounded-[8px] opacity-72 bg-[linear-gradient(93deg,#6F52ED_0.64%,#845EC2_99.52%)] mt-[1rem] text-white text-center font-outfit text-[14px] font-medium leading-[19px] tracking-[0.14px] hover:opacity-100 transition-opacity cursor-pointer"
                  onClick={() => {
                    setShowGetStarted(false);
                    window.location.href = "/ai-Copilot";
                  }}
                >
                  Get Started Now
                </button>
              </div>
            </div>
          );
        })()
      )}
    </div>
  );
};

export default Pricing;